import SystemModuleUiService, {SubscribeModuleUiService} from "app/Service/System/Module/SystemModuleUiService"
import InvoiceGeneralSettingsButtons from "app/WebController/Toolbar/Settings/InvoiceGeneralSettingsButtons"
import InvoiceNumberSettingsToolbar from "app/WebController/Toolbar/Settings/InvoiceNumberSettingsToolbar"
import LayoutToolbar from "app/WebController/Toolbar/Settings/LayoutToolbar"
import {Module} from "const/Module"
import Logger from "logger/logger"
import React, {useEffect, useMemo} from "react"

function ToolbarModuleSettingsController() {
  const {activeSystemModuleUi} = SystemModuleUiService([
    SubscribeModuleUiService.active
  ], 'ToolbarSettingsController')

  const invoiceGeneralSettingsButtons = InvoiceGeneralSettingsButtons()

  useEffect(() => {
    Logger('Toolbar.Settings.Controller.init')
    return () => {
      Logger('Toolbar.Settings.Controller.unloading')
    }
  }, [])

  return useMemo(() => {
    if (undefined === activeSystemModuleUi?.settings?.navLink)
      return null

    switch (activeSystemModuleUi?.settings?.navLink) {
      case Module.layout:
        return <LayoutToolbar/>
      case Module.invoiceNumberSettings:
        return <InvoiceNumberSettingsToolbar/>
      case Module.invoiceDefaultSettings:
        return <InvoiceGeneralSettingsButtons/>
      default:
        return null
    }
  }, [activeSystemModuleUi, invoiceGeneralSettingsButtons])

}

export default ToolbarModuleSettingsController
